import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'

import renderCurrencyInput from '../../../../components/ui/forms/renderCurrencyInput'
import SearchBoxWithSuggestionsFromNetwork from '../../../../components/ui/forms/SearchBoxWithSuggestionsFromNetwork'
import constants from '../../../../utils/constants/application'
import formValidators from '../../../../utils/validation/formValidators'
const { autoCompleteIndices } = constants

class CollegeAndTuitionForm extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onChangeCollegeState: PropTypes.func,
    onChangeUniversity: PropTypes.func.isRequired,
    onSalarySearch: PropTypes.func.isRequired,
    showSalaryFields: PropTypes.bool.isRequired,
    isPerformingSearch: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.onUniversitySuggestionSelected = value => {
      this.props.change('university', value)
      this.props.onChangeUniversity(value)
    }
  }

  render() {
    const { onChange, onSalarySearch, showSalaryFields, isPerformingSearch } = this.props

    return (
      <form id="collegeSearch">
        <Field
          className="LoNotSensitive"
          component={SearchBoxWithSuggestionsFromNetwork}
          field={autoCompleteIndices.universityDisplay}
          label="COLLEGE/UNIVERSITY"
          name="university"
          onSuggestionSelected={this.onUniversitySuggestionSelected}
          placeholder="University Search"
          search={false}
          tipContent="Start typing to find your University"
        />
        <div id="amount" style={{ marginTop: 10 }}>
          <Field
            onChange={onChange}
            name="amount"
            label="4-Year Average Net Price"
            placeholder="80,367"
            type="number"
            component={renderCurrencyInput}
            tipContent="4-Year Average Net Price listed in the IPEDS dataset"
          />
        </div>
        {showSalaryFields && (
          <div className="shake-on-load">
            <hr />
            <h6 style={{ marginBottom: 5 }}>Breakeven</h6>
            <div id="tuitionSalarySearch" style={{ marginBottom: 10 }}>
              <Field
                name="salarySearch"
                field={autoCompleteIndices.jobTitles}
                placeholder="Job Title"
                component={SearchBoxWithSuggestionsFromNetwork}
                label="What do you want to be?"
                className="LoNotSensitive"
                isPerformingSearch={isPerformingSearch}
                onSuggestionSelected={onSalarySearch}
                search={false}
                shadow={false}
              />
            </div>
            <Field
              onChange={onChange}
              name="startingSalaryWithDegree"
              id="startingSalaryWithDegree"
              label="Salary With Degree"
              placeholder="50,000"
              component={renderCurrencyInput}
              tipContent="Average Salary for the selected job title"
            />
          </div>
        )}
      </form>
    )
  }
}

const validate = values => {
  const errors = {}
  if (values.university) {
    errors.university = formValidators.maxLengthTwoHundred(values.university)
  }

  if (values.salarySearch) {
    errors.salarySearch = formValidators.maxLengthTwoHundred(values.salarySearch)
  }

  return errors
}

const wrappedWithForm = reduxForm({
  enableReinitialize: true,
  form: 'collegeAndTuitionForm',
  destroyOnUnmount: false,
  validate,
})(CollegeAndTuitionForm)

export default wrappedWithForm



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/CollegeAndTuitionForm.js